export default __webpack_public_path__ + "static/media/class_xi_xii.6cde68a7.png";